import { styled } from '@linaria/react'
import React, { FC, ReactNode } from 'react'
import { NavLink } from 'react-router'
import { textOverflowCss } from '../styles/textOverflowCss'
import { Typography } from './Typography'
import { colors } from '../styles/colors'

export type TabId = string | number
type Tab = { to: string; id: TabId; label: ReactNode }

export const Tabs: FC<{
  tabs: Tab[]
  activeTabId: TabId
  onTabChange?: (id: TabId) => void
}> = ({ tabs, activeTabId, onTabChange }) => {
  const handleTabClick = (id: TabId) => {
    onTabChange?.(id)
  }

  return (
    <TabsContainer columns={tabs.length}>
      {tabs.map(tab => (
        <NavLink
          className={textOverflowCss}
          key={tab.id}
          to={tab.to}
          style={{ width: '100%' }}
          replace
          prefetch="render"
        >
          <Tab
            className={textOverflowCss}
            isActive={tab.id === activeTabId}
            onClick={() => handleTabClick(tab.id)}
          >
            <Label className={textOverflowCss} fontSize={16} fontWeight={500}>
              {tab.label}
            </Label>
          </Tab>
        </NavLink>
      ))}
    </TabsContainer>
  )
}

const TabsContainer = styled.div<{ columns: number }>`
  display: grid;
  grid-template-columns: repeat(${props => props.columns}, 1fr);
  grid-auto-flow: column;
  gap: 4px;
  border-radius: 16px;
  background: ${colors.bgSecondary};
  overflow: hidden;
`
const Label = styled(Typography)``

const Tab = styled.button<{ isActive: boolean }>`
  width: 100%;
  flex: 1;
  text-align: center;
  border: none;
  background-color: ${({ isActive }) =>
    isActive ? colors.secondary : 'transparent'};
  cursor: pointer;
  transition: background-color 0.3s;
  padding: 8px 12px;
  border-radius: 26px;

  ${Label} {
    color: ${({ isActive }) => (isActive ? colors.white : colors.textPrimary)};
    transition: color 0.3s;
  }
`
